/**
 * Teppichstadt Theme - Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  


  // --- Yeezy Enter Page Controller ---
  const enterOverlay = document.getElementById('EnterPageOverlay');
  const enterTriggers = document.querySelectorAll('.enter-trigger');
  const enterAudio = document.getElementById('EnterAudio');
  const enterAudioToggle = document.getElementById('EnterAudioToggle');

  // Check if we are in overlay mode
  const isOverlayMode = enterOverlay && enterOverlay.classList.contains('is-overlay');

  if (enterOverlay) {
    document.body.classList.remove('enter-page-active');

    // Audio vibe player handler
    let audioStarted = false;
    if (enterAudio && enterAudioToggle) {
      const playAudio = () => {
        enterAudio.volume = 0;
        enterAudio.play().then(() => {
          audioStarted = true;
          enterAudioToggle.innerHTML = '<span class="enter-audio-icon playing"></span> Mute Vibe';
          // Fade in audio volume
          let vol = 0;
          const fadeInterval = setInterval(() => {
            if (vol < 0.4) {
              vol += 0.05;
              enterAudio.volume = vol;
            } else {
              clearInterval(fadeInterval);
            }
          }, 100);
        }).catch(err => console.log('Autoplay blocked or audio failed:', err));
      };

      const pauseAudio = () => {
        let vol = enterAudio.volume;
        const fadeInterval = setInterval(() => {
          if (vol > 0.05) {
            vol -= 0.05;
            enterAudio.volume = vol;
          } else {
            clearInterval(fadeInterval);
            enterAudio.pause();
            audioStarted = false;
            enterAudioToggle.innerHTML = '<span class="enter-audio-icon"></span> Play Vibe';
          }
        }, 50);
      };

      enterAudioToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (audioStarted) {
          pauseAudio();
        } else {
          playAudio();
        }
      });
      
      // Auto-start audio vibe on first user interaction with the enter page
      document.addEventListener('click', function autoPlayVibe() {
        if (!audioStarted && enterAudio && enterOverlay.style.display !== 'none') {
          playAudio();
        }
        document.removeEventListener('click', autoPlayVibe);
      }, { once: true });
    }

    // Enter trigger click logic
    enterTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        // If in overlay mode, fade out and do not navigate away if the link is just a close trigger
        const href = this.getAttribute('href');
        const isCloseOnly = this.classList.contains('enter-close-only') || href === '#' || href === '';

        if (isOverlayMode) {
          if (isCloseOnly) {
            e.preventDefault();
          }
          
          // Play transition
          enterOverlay.classList.add('entered');
          document.body.classList.remove('enter-page-active');
          
          // If navigating, wait for transition to end before navigating
          if (!isCloseOnly && href && href !== '#') {
            e.preventDefault();
            setTimeout(() => {
              window.location.href = href;
            }, 800); // matches CSS transition duration
          } else {
            // Just hide completely after animation
            setTimeout(() => {
              enterOverlay.style.display = 'none';
            }, 800);
          }
        } else {
          // In standalone mode, let it navigate normally, but we can unlock body scroll
          document.body.classList.remove('enter-page-active');
        }
      });
    });
  }

  // Shopify Customizer Support: Listen to section selection events
  document.addEventListener('shopify:section:select', function(event) {
    if (event.detail.sectionId === 'enter-page') {
      const overlay = document.getElementById('EnterPageOverlay');
      if (overlay) {
        overlay.style.display = 'block';
        overlay.classList.remove('entered');
        document.body.classList.add('enter-page-active');
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    if (event.detail.sectionId === 'enter-page') {
      const overlay = document.getElementById('EnterPageOverlay');
      if (overlay && overlay.classList.contains('is-overlay')) {
        overlay.style.display = 'none';
        document.body.classList.remove('enter-page-active');
      }
    }
  });

  // 2. Mobile Burger Menu Toggler
  const burgerToggle = document.getElementById('BurgerMenuToggle');
  const headerMenu = document.querySelector('.header-menu');
  const burgerIcon = document.querySelector('.burger');
  const crossIcon = document.querySelector('.cross');
  
  if (burgerToggle && headerMenu) {
    burgerToggle.addEventListener('click', function() {
      const isActive = headerMenu.classList.toggle('active');
      
      if (isActive) {
        if (burgerIcon) burgerIcon.style.display = 'none';
        if (crossIcon) crossIcon.style.display = 'block';
        document.body.style.overflow = 'hidden';
      } else {
        if (burgerIcon) burgerIcon.style.display = 'block';
        if (crossIcon) crossIcon.style.display = 'none';
        document.body.style.overflow = 'auto';
      }
    });
  }

  // 3. Cart Drawer Toggle Controls
  const cartTrigger = document.getElementById('CartDrawerTrigger');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartMask = document.getElementById('CartDrawerMask');
  const cartClose = document.getElementById('CartDrawerClose');

  function openCartDrawer() {
    if (cartDrawer && cartMask) {
      cartDrawer.classList.add('active');
      cartMask.classList.add('active');
      document.body.style.overflow = 'hidden';
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartMask.setAttribute('aria-hidden', 'false');
    }
  }

  function closeCartDrawer() {
    if (cartDrawer && cartMask) {
      cartDrawer.classList.remove('active');
      cartMask.classList.remove('active');
      document.body.style.overflow = 'auto';
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartMask.setAttribute('aria-hidden', 'true');
    }
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', function(e) {
      if (window.cartType === 'drawer') {
        e.preventDefault();
        openCartDrawer();
      }
    });
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartMask) {
    cartMask.addEventListener('click', closeCartDrawer);
  }

  // Global triggers to open the drawer
  window.openCart = openCartDrawer;

  // 4. EU Revocation Modal Dialog Handler (Accessible Native Dialog)
  const revocationModal = document.getElementById('RevocationModal');
  const revocationTriggers = document.querySelectorAll('.revocation-trigger');
  const revocationClose = document.getElementById('RevocationModalClose');

  if (revocationModal) {
    revocationTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        // Prevent event propagation if nested inside other triggers
        e.stopPropagation();
        revocationModal.showModal();
        document.body.style.overflow = 'hidden';
      });
    });

    if (revocationClose) {
      revocationClose.addEventListener('click', function() {
        revocationModal.close();
        document.body.style.overflow = 'auto';
      });
    }

    // Close when clicking outside of the modal wrapper (on the backdrop)
    revocationModal.addEventListener('click', function(e) {
      const rect = revocationModal.getBoundingClientRect();
      const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height
        && rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
      if (!isInDialog) {
        revocationModal.close();
        document.body.style.overflow = 'auto';
      }
    });
  }

  // 5. Product Accordions Toggles
  const accordionToggles = document.querySelectorAll('.accordion-toggle');
  accordionToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const item = this.parentElement;
      const isActive = item.classList.toggle('active');
      
      const content = item.querySelector('.accordion-content');
      if (content) {
        content.style.display = isActive ? 'block' : 'none';
      }
      
      const icon = this.querySelector('.toggle-icon');
      if (icon) {
        icon.textContent = isActive ? '-' : '+';
      }
    });
  });

  // 5b. Product Page Quantity Button Handlers (+ / -)
  const qtyMinus = document.getElementById('prod-qty-minus');
  const qtyPlus = document.getElementById('prod-qty-plus');
  if (qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      const input = this.closest('.product-qty-selector').querySelector('.product-qty-input');
      let currentVal = parseInt(input.value) || 1;
      if (currentVal > 1) {
        input.value = currentVal - 1;
      }
    });
    qtyPlus.addEventListener('click', function() {
      const input = this.closest('.product-qty-selector').querySelector('.product-qty-input');
      let currentVal = parseInt(input.value) || 1;
      input.value = currentVal + 1;
    });
  }

  // 6. Dynamic AJAX Cart Operations inside the Drawer
  const drawerContent = document.getElementById('CartDrawerContent');
  if (drawerContent) {
    drawerContent.addEventListener('click', function(e) {
      
      // Handle Plus/Minus buttons
      if (e.target.classList.contains('qty-btn')) {
        const button = e.target;
        const key = button.getAttribute('data-key');
        const change = parseInt(button.getAttribute('data-change'));
        const qtySpan = button.parentElement.querySelector('.qty-display');
        let currentQty = parseInt(qtySpan.textContent);
        let newQty = currentQty + change;
        if (newQty < 0) newQty = 0;

        updateCartItemQuantity(key, newQty);
      }

      // Handle Remove items link
      if (e.target.classList.contains('cart-drawer-item__remove-link')) {
        const key = e.target.getAttribute('data-key');
        updateCartItemQuantity(key, 0);
      }

    });
  }

  function updateCartItemQuantity(itemKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartCountUI(cart.item_count);
      refreshCartDrawerUI();
    })
    .catch(error => {
      console.error('Error updating shopping bag:', error);
    });
  }

  function updateCartCountUI(count) {
    const cartCountElement = document.getElementById('CartCount');
    if (cartCountElement) {
      cartCountElement.textContent = count;
    }
  }

  // Refreshes the cart drawer contents dynamically by loading /cart section
  function refreshCartDrawerUI() {
    fetch('/?sections=cart-drawer')
      .then(response => response.json())
      .then(sections => {
        const html = sections['cart-drawer'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Replace inner content and footer visibility
        const currentDrawerContent = document.getElementById('CartDrawerContent');
        const newDrawerContent = doc.getElementById('CartDrawerContent');
        if (currentDrawerContent && newDrawerContent) {
          currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
        }

        const currentDrawerFooter = document.querySelector('.cart-drawer__footer');
        const newDrawerFooter = doc.querySelector('.cart-drawer__footer');
        if (currentDrawerFooter && newDrawerFooter) {
          currentDrawerFooter.innerHTML = newDrawerFooter.innerHTML;
          currentDrawerFooter.style.display = newDrawerFooter.style.display;
        }
      })
      .catch(error => {
        console.error('Error updating cart view:', error);
      });
  }

  // Hook global cart refresh for custom product page integrations
  window.refreshCartDrawer = refreshCartDrawerUI;
  window.updateCartCount = updateCartCountUI;

});
